import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Typography from '#web-components/components/Typography';
import { formatUTCDateTime } from '#web-components/utils';
import InlineButton from '#web-components/components/InlineButton';

import styles from './NotificationItem.styles';

const useStyles = makeStyles(styles, { name: 'NotificationItem' });

export interface Notification {
  id: string;
  isAcknowledged: boolean;
  subject: string;
  message: string;
  createdAt: string;
}

export type Props = {
  notification: Notification;
  onOpen: (notification: Notification) => void;
  localization: {
    newOne: string;
    hide: string;
    show: string;
  },
};

function NotificationItem({
  notification, onOpen, localization,
}: Props) {
  const classes = useStyles();
  const {
    subject, message, isAcknowledged, createdAt,
  } = notification;
  const [isOpened, setIsOpened] = useState(false);

  const toggleItem = () => {
    setIsOpened((prev) => {
      if (!prev) onOpen(notification);
      return !prev;
    });
  };

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.titleWrapper}>
          <Typography variant="textRegular">{formatUTCDateTime(createdAt)}</Typography>
          {!isAcknowledged
          && <Typography variant="accentTiny" className={classes.label}>{localization.newOne}</Typography>}
        </div>
        <div className={clsx(classes.messageWrapper, !isOpened && classes.messageWrapperClosed)}>
          <Typography variant="h4">{subject}</Typography>
          <Typography variant="textRegular" className={classes.message}>{message}</Typography>
        </div>
      </div>
      <div className={classes.btnWrapper}>
        <InlineButton
          size="medium"
          rightIcon={<ArrowDropDownIcon className={clsx({ [classes.iconActive]: isOpened })} />}
          onLinkClick={toggleItem}
        >
          {isOpened ? localization.hide : localization.show}
        </InlineButton>
      </div>
    </div>
  );
}

export default NotificationItem;
